<!-- Genetic report — the hero action of the patient passport.
     Lives inside the passport's .genetics-card; renders the upload flow,
     processing spinner, and validation status as a single action card. -->
<div class="genetics" [class.is-done]="isComplete">

  <div class="genetics-head">
    <div class="g-dot" [class.ok]="isComplete" [class.busy]="showSpinner" aria-hidden="true">
      <mat-icon>{{ isComplete ? 'check' : (showSpinner ? 'hourglass_top' : 'biotech') }}</mat-icon>
    </div>
    <div class="g-ttl">
      <div class="t">{{ 'PATIENT_DETAIL.HOME.GENETIC_REPORT' | translate }}</div>
      <div class="s" [class.ok]="isComplete">{{ headerSubtitleKey | translate }}</div>
    </div>
  </div>

  <div class="genetics-body">

    @if (show_instructions) {
      <p class="g-instructions">{{ 'PATIENT_DETAIL.CONTENT.MUTATIONS.TABLE.NO_DATA' | translate }}</p>
      <p class="g-instructions muted" [innerHTML]="'PATIENT_DETAIL.CONTENT.MUTATIONS.TABLE.NO_DATA_MORE_DETAILS' | translate"></p>
    }

    @if (allow_upload) {
      <div class="g-actions">
        <button
          type="button"
          class="g-btn primary"
          (click)="fileInput.click()"
          [disabled]="disableButton"
          [attr.aria-label]="'PATIENT_DETAIL.ACTIONS.ADD_DIAGNOSIS_FILE' | translate">
          <mat-icon aria-hidden="true">cloud_upload</mat-icon>
          {{ 'PATIENT_DETAIL.ACTIONS.ADD_DIAGNOSIS_FILE' | translate }}
        </button>
        <button
          type="button"
          class="g-btn ghost"
          (click)="openDocumentScanner()"
          [disabled]="disableButton"
          [attr.aria-label]="'PATIENT_DETAIL.ACTIONS.SCAN_DOCUMENT' | translate">
          <mat-icon aria-hidden="true">document_scanner</mat-icon>
          {{ 'PATIENT_DETAIL.ACTIONS.SCAN_DOCUMENT' | translate }}
        </button>
        <input #fileInput type="file" hidden (change)="onFileMutationSelected($event)"
               [attr.aria-label]="'PATIENT_DETAIL.ACTIONS.ADD_DIAGNOSIS_FILE' | translate">
      </div>
      <p class="g-help">{{ 'PATIENT_DETAIL.CONTENT.MUTATIONS.TABLE.NO_DATA_FILE_INFO' | translate }}</p>
    }

    @if (showSpinner) {
      <div class="g-spin" role="status" aria-live="polite" aria-busy="true">
        <mat-spinner [diameter]="22" aria-hidden="true"></mat-spinner>
        <span>{{ 'PATIENT_DETAIL.CONTENT.PROCESSING_IN_PROGRESS' | translate }}</span>
      </div>
    }

    @if (show_status && isErrorState(getDisplayStatusState())) {
      <div class="g-status" [ngClass]="getStatusClass(getDisplayStatusState())" role="status" aria-live="polite">
        <mat-icon class="g-status-icon" aria-hidden="true">error_outline</mat-icon>
        <div class="g-status-text">
          <div class="g-status-label">{{ getStatusLabel(getDisplayStatusState()) | translate }}</div>
          @if (mutationStatus?.validation_description) {
            <div class="g-status-desc">{{ mutationStatus.validation_description }}</div>
          }
          <div class="g-status-meta">
            {{ 'PATIENT_DETAIL.CONTENT.MUTATIONS.STATUS.LATEST_UPDATE' | translate }}:
            {{ mutationStatus.last_updated_at | date:'longDate':undefined:currentLang }}
          </div>
        </div>
      </div>
    }

  </div>
</div>
